<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue'

import type { FieldClass } from '@/api/fields'
import type { IToolBarButton } from '@/types/serverField.type'
import type { Component } from 'vue'

const { buttons, field, parentUuid = '' } = defineProps<{
  buttons: IToolBarButton[]
  field: FieldClass
  parentUuid?: string
}>()
const emit = defineEmits(['updateData'])

const buttonComponents: Record<string, Component> = {
  refresh: defineAsyncComponent(() => import('./Buttons/UpdateButton.vue')),
  popup_query: defineAsyncComponent(() => import('./Buttons/UpdateCoursesButton.vue')),
  export: defineAsyncComponent(() => import('./Buttons/ExportButton.vue')),
  import: defineAsyncComponent(() => import('./Buttons/ImportButton.vue')),
  popup_form: defineAsyncComponent(() => import('./Buttons/PopupFormButton.vue')),
  '': defineAsyncComponent(() => import('./Buttons/AddButton.vue'))
}

const getProps = (button: IToolBarButton) => {
  const props: Record<string, any> = {
    btn: button,
  }

  if (['export', 'import'].includes(button.action)) {
    props.field = field
  }

  if (button.action === 'popup_form') {
    props.params = button.params
    props.parentUuid = parentUuid
  }

  return props
}

const preparedButtons = computed(() => {
  return buttons.filter(btn => {
    if (!buttonComponents[btn.action]) {
      console.error(`Не найден компонент кнопки для действия "${btn.action}"`, btn)
      return false
    }

    return true
  })
})

</script>

<template>
  <VBtnGroup
    class="widget-toolbar"
    variant="outlined"
    density="compact"
  >
    <component
      :is="buttonComponents[button.action]"
      v-for="button in preparedButtons"
      :key="button.title"
      v-bind="getProps(button)"
      @update-data="emit('updateData')"
    />
  </VBtnGroup>
</template>

<style lang="scss" scoped>
.widget-toolbar {
  height: 30px !important;
}
</style>
